import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'
import { EMAIL_STATISTICS_API } from '../../../mailing/email-statistics/api/email-statistics-api'
import { RemovalConditionsInterface } from '../types/removal-conditions-interface'

export function useRemovalConditions() {
  const { user, isWorkspaceOwner, isWsAdmin } = useUser()
  const canManageRemovalConditions = isWorkspaceOwner || isWsAdmin

  const { fetcher } = useFetch<RequestMethodsEnum.get, RemovalConditionsInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: removalConditions, mutate } = useSWR(() => {
    if (user && canManageRemovalConditions) {
      return `${EMAIL_STATISTICS_API}/contact/removal-conditions/list`
    }
    return null
  }, fetcher)

  return { removalConditions, mutate, canManageRemovalConditions }
}
